import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { useMutation, useQueryClient } from 'react-query';
import { endPoints } from '../utils/constants/endPoints';

export function useMonetaryPaymentDelete() {
  const qc = useQueryClient();
  return useMutation(
    async (id: number) => {
      const res = await $api.delete(endPoints.MONETARY_PAYMENT_ID(id));
      return res.data;
    },
    {
      onSuccess: data => {
        qc.invalidateQueries([queryNames.MONETARY_PAYMENT_FILTER]);
        qc.invalidateQueries([queryNames.MONETARY_PAYMENT_FILTER_COUNT]);
        showMessage(data.message, data.accept);
      },
      onError: baseErrorHandler
    }
  );
}
